import React from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography, Paper, InputLabel } from "@material-ui/core";
import Footer from "../Landingpagecomponents/Footer/Footer"

const FAQ = () => {
    return(
        <Grid container style={{backgroundColor: "#eaeaea"}}>
            <Header/>
            <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
            <Grid container justify="center" style={{marginTop: 20}}>
            <Paper item xs={12}  style={{width: "70%", margin: 20, padding: 20}}>
                    <Typography style={{color: "#002D55"}}>
                        <h1>FAQ - Questions & Answers</h1>
                        <h2 style={{color: "#002D55"}}>Which patients and symptoms are suitable for virtual physiotherapy?</h2>
                        <p>
                           text 
                        </p>
                        <h2 style={{color: "#002D55"}}>When should you see a doctor instead?</h2>
                        <p>
                            text
                        </p>
                        <h2 style={{color: "#002D55"}}>How is virtual physiotherapy different than traditional physiotherapy?</h2>
                        <p>
                            text
                        </p>
                        <h2 style={{color: "#002D55"}}>How can virtual physiotherapy help you?</h2>
                        <p>
                            text
                        </p>
                        <h2 style={{color: "#002D55"}}>Is virtual physiotherapy just as good as traditional physiotherapy?</h2>
                        <p>
                            text
                        </p>
                        <h2 style={{color: "#002D55"}}>Cases where virtual physiotherapy is not recommended:</h2>
                        <p>
                            text
                        </p>                        
                    </Typography>
                </Paper>
            </Grid>
        <Grid xs={12} container justify="center" justifyContent="center">
            <Footer />
        </Grid>
        </Grid>
        );
    };

export default FAQ;